import { isActiveJobStatus } from './trainingJobRetry';

export const CONNECTOR_OPT_POLLING_STORAGE_PREFIX = 'connector_opt_poll_job:';

export const OPTIMIZATION_JOB_SUCCEEDED_STATUSES = [
  'succeeded',
  'completed',
  'complete',
  'success',
  'done',
  'finished',
] as const;

export const OPTIMIZATION_JOB_FAILED_STATUSES = ['failed', 'error'] as const;

export const OPTIMIZATION_JOB_CANCELLED_STATUSES = ['cancelled', 'canceled'] as const;

export const OPTIMIZATION_JOB_TERMINAL_STATUSES = [
  ...OPTIMIZATION_JOB_SUCCEEDED_STATUSES,
  ...OPTIMIZATION_JOB_FAILED_STATUSES,
  ...OPTIMIZATION_JOB_CANCELLED_STATUSES,
  'partially_succeeded',
] as const;

export function normalizeOptimizationJobStatus(status: string | undefined | null): string {
  return String(status || '')
    .trim()
    .toLowerCase();
}

export function isSucceededOptimizationJobStatus(status: string | undefined | null): boolean {
  const normalized = normalizeOptimizationJobStatus(status);
  return (OPTIMIZATION_JOB_SUCCEEDED_STATUSES as readonly string[]).includes(normalized);
}

export function isFailedOptimizationJobStatus(status: string | undefined | null): boolean {
  const normalized = normalizeOptimizationJobStatus(status);
  return (OPTIMIZATION_JOB_FAILED_STATUSES as readonly string[]).includes(normalized);
}

export function isCancelledOptimizationJobStatus(status: string | undefined | null): boolean {
  const normalized = normalizeOptimizationJobStatus(status);
  return (OPTIMIZATION_JOB_CANCELLED_STATUSES as readonly string[]).includes(normalized);
}

export function isTerminalOptimizationJobStatus(status: string | undefined | null): boolean {
  const normalized = normalizeOptimizationJobStatus(status);
  return (OPTIMIZATION_JOB_TERMINAL_STATUSES as readonly string[]).includes(normalized);
}

export function connectorOptPollingStorageKey(integrationId: string): string {
  return CONNECTOR_OPT_POLLING_STORAGE_PREFIX + integrationId;
}

export function readPersistedOptimizationJobId(integrationId: string): string | null {
  try {
    const raw = sessionStorage.getItem(connectorOptPollingStorageKey(integrationId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { jobId?: unknown };
    if (typeof parsed?.jobId === 'string' && parsed.jobId.trim()) {
      return parsed.jobId.trim();
    }
  } catch {
    // ignore
  }
  return null;
}

export function clearPersistedOptimizationJobId(integrationId: string | null | undefined): void {
  if (!integrationId) return;
  try {
    sessionStorage.removeItem(connectorOptPollingStorageKey(integrationId));
  } catch {
    // ignore
  }
}

export function hasAnyPersistedOptimizationJobId(): boolean {
  try {
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const key = sessionStorage.key(i);
      if (!key?.startsWith(CONNECTOR_OPT_POLLING_STORAGE_PREFIX)) continue;
      const integrationId = key.slice(CONNECTOR_OPT_POLLING_STORAGE_PREFIX.length);
      if (readPersistedOptimizationJobId(integrationId)) return true;
    }
  } catch {
    // ignore
  }
  return false;
}

export function shouldTrackOptimizationJob(status: string | undefined | null): boolean {
  return isActiveJobStatus(status);
}
